// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"oW-z","inlineTitle":"pW-z","sponsoredAdsWrapper":"qW-z","marketplaceRecosWrapper":"rW-z"};